<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('table.action.modify') }}</div>
    <div slot="body">
      <a-table :columns="columns" :data-source="data" :pagination="false">
        <template #providerShow="text, record">
          <brand-icon :name="record.provider" :customStyle="getBrandStyle(record.provider)" />
        </template>
        <template #productTypeShow="text, record">
          <div style="width: 200px">
            <select-or-input v-model="record.product_type" showSwitchText :name="$t('bill.product_type')" valueType="String" filterable forceInitType="select" :options="typeOpts" @change="(val) => typeChange(record.id, val)" />
          </div>
        </template>
      </a-table>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { typeClouds } from '@/utils/common/hypervisor'
import BrandIcon from '@/sections/BrandIcon'
const brandMap = typeClouds.getBrand()

export default {
  name: 'BillProductUpdateDialog',
  components: {
    BrandIcon,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      typeOpts: [],
      columns: [
        {
          dataIndex: 'origin_res_type',
          title: this.$t('bill.origin_res_type'),
        },
        {
          dataIndex: 'provider',
          title: this.$t('bill.text_81'),
          scopedSlots: {
            customRender: 'providerShow',
          },
        },
        {
          dataIndex: 'origin_usage_type',
          title: this.$t('bill.origin_usage_type'),
        },
        {
          dataIndex: 'product_type',
          title: this.$t('bill.product_type'),
          scopedSlots: {
            customRender: 'productTypeShow',
          },
        },
      ],
      data: this.params.data,
      changedData: {},
    }
  },
  created () {
    this.$r = new this.$Manager('bill_products', 'v1')
    this.fetchProductType()
  },
  methods: {
    getBrandStyle (brand) {
      if (brand === brandMap.Baidu.provider) {
        return { fontSize: '16px', marginLeft: '2px' }
      }
      return {}
    },
    fetchProductType () {
      this.$r.list({
        params: {
          group_by: 'product_type',
        },
      }).then(res => {
        this.typeOpts = res.data.data.map(item => ({
          id: item.product_type,
          name: item.product_type,
        }))
      })
    },
    async handleConfirm () {
      try {
        const keys = Object.keys(this.changedData)
        if (keys.length === 0) {
          this.$message.error(this.$t('bill.no_change'))
          return
        }
        const list = []
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          if (this.changedData[key]) {
            list.push({
              id: key,
              product_type: this.changedData[key],
            })
          } else {
            this.$message.error(this.$t('common.tips.input', [this.$t('bill.product_type')]))
            return
          }
        }
        this.loading = true
        if (keys.length === 1) {
          await this.params.onManager('update', {
            id: keys[0],
            managerArgs: {
              data: {
                product_type: this.changedData[keys[0]],
              },
            },
          })
        } else {
          await new this.$Manager('bill_products/batch-update', 'v1').create({
            data: {
              data: list,
            },
          })
          this.params.ok()
        }
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
    typeChange (id, record) {
      this.changedData[id] = record
    },
  },
}
</script>
